import { gql } from "graphql-tag";

// Every field selected here is declared on NotificationListType / NotificationItemType (server type).
export const getNotifications = gql`
  query getNotifications($limit: Int, $offset: Int) {
    getNotifications(limit: $limit, offset: $offset) {
      result {
        id
        title
        body
        type
        deepLink
        isRead
        createdAt
      }
      status
      errorMessage
      unreadCount
      totalCount
    }
  }`;

export const markNotificationRead = gql`
  mutation markNotificationRead($notificationId: Int, $markAll: Boolean) {
    markNotificationRead(notificationId: $notificationId, markAll: $markAll) {
      status
      errorMessage
      unreadCount
    }
  }`;
